import React from 'react';
import { createPortal } from 'react-dom';
import { useRouter } from 'next/router';
import { useMemberTimeStore } from 'lowcode/utils/context/memberTimeZone';
import { message } from 'antd-v5';
import styled from './index.module.scss';
import { CouponMiniIcon } from '@/components/UI/svg/Ecocredits';
import EcoCredits from '@/components/UI/svg/Icons/EcoCredits';
import { useLang } from '@/app/utils/useLang';
import FullScreenModal from '@/components/EcoCredits/FullScreenModal';
import getLocal from '@/app/utils/getLocal';
import GrabEcoCreditsBonus from '@/components/EcoCredits/GrabEcoCreditsBonus';
import { injectNotes } from '@/components/EcoCredits/utils';
import { useMembersStore } from '@/components/MembersDay/MembersProvider';
import { getDiscountCouponListNew, getIsShowIcon, getDiscountCouponListNew1 } from '@/service/vip';
import { getIsLogin } from '@/utils/cookie';

const WelfareCenter = () => {
    const { t } = useLang('membersday.welfare');
    const { t: t1 } = useLang('membersday.membersdaytask25');
    const { t: t2 } = useLang('ecocredits');
    const { locale } = getLocal();
    const router = useRouter();
    const { campaignInfo, inBlackList } = useMembersStore();
    const [isBrowser, setIsBrowser] = React.useState(false);
    const [discountCouponList, setDiscountCouponList] = React.useState<any[]>([]);
    const [showPage, setShowPage] = React.useState('basic'); // basic / history_modal / coupon_modal / points_modal / bouns_modal / qhistory_modal / lucky_history
    // const [issuedCoupon, setIssuedCoupon] = React.useState<any[]>([]);
    const [isShowIcon, setIsShowIcon] = React.useState(false);

    const { timezoneList } = useMemberTimeStore();

    const handleInBlackList = () => {
        if (inBlackList) {
            message.error(t1('membersdaybanner25_no_eligible'));
            return;
        }
    };

    const queryDiscountCouponList = async () => {
        handleInBlackList();
        const isLogin = getIsLogin();
        const apiRequestFn = !isLogin ? getDiscountCouponListNew1 : getDiscountCouponListNew;
        const res = await apiRequestFn(locale as string, campaignInfo?.campaignId);
        if (res?.code === '0') {
            const coupons = injectNotes(res.data, t2, locale as string, timezoneList);
            setDiscountCouponList(coupons || []);
            // const isHasUnUsedCoupons = coupons?.some((coupon: any) => coupon?.receiveStatus === 1 || !coupon?.receiveStatus);
            // firstIn && isHasUnUsedCoupons && setShowPage('bouns_modal');
            // setFirstIn(false);
        }
    };

    // const queryIssuedRewards = async () => {
    //     const res = await getIssuedCoupons(locale as string);
    //     if (res?.code === '0') {
    //         const coupons = injectNotes(res?.data || [], t, locale as string);
    //         setIssuedCoupon(coupons || []);
    //     }
    // };

    React.useEffect(() => {
        const fetchRemoteInfo = async (id: string) => {
            const res = await getIsShowIcon(id, locale);
            if (res?.code === '0') {
                setIsShowIcon(!!res?.data);
            }
        };

        if (campaignInfo && campaignInfo?.campaignId) {
            fetchRemoteInfo(campaignInfo?.campaignId);
        }
    }, [locale, campaignInfo]);

    React.useEffect(() => {
        if (router?.query?.modal === 'bonus_modal') {
            setShowPage('bouns_modal');
            router.replace(`${window.location.origin}${window.location.pathname}`);
        }
    }, [router]);

    React.useEffect(() => {
        setIsBrowser(true);
    }, []);

    const content = (
        <>
            <div
                className={styled.WelfareCenter}
                onClick={() => {
                    setShowPage('bouns_modal');
                }}
            >
                <div className="welfare-content">
                    <div className="welfare-desc">
                        <span className="welfare-text">{t('grab_title')}</span>
                        <span className="welfare-coupon-icon">
                            <CouponMiniIcon />
                        </span>
                    </div>
                    <div className="welfare-icon">
                        <EcoCredits />
                    </div>
                </div>
            </div>
            <FullScreenModal
                visible={showPage === 'bouns_modal'}
                zIndex={1200}
                className={`bouns_modal top bouns_modal`}
                closeModal={() => {
                    setShowPage('');
                }}
                style={{ background: '#f5f5f5' }}
                afterOpen={() => {
                    queryDiscountCouponList();
                }}
            >
                <GrabEcoCreditsBonus
                    coupons={discountCouponList}
                    setShowPage={setShowPage}
                    visible={showPage === 'bouns_modal'}
                    isNeedValidate={true}
                    rewardsRedirect={true}
                    refershData={() => {
                        // queryIssuedRewards();
                        queryDiscountCouponList();
                    }}
                />
            </FullScreenModal>
        </>
    );

    if (isBrowser && isShowIcon) {
        return createPortal(content, document.body);
    }

    return null;
};

export default WelfareCenter;
